module.exports = __webpack_public_path__ + "static/media/HardmodeNeon_main_t.e21751eb.jpg";